import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import CommonHeader from '@/components/CommonHeader.vue';
import AjaxButton from '@/components/AjaxButton.vue';
import UserService from '@/services/UserService';
let InvoiceRegister = class InvoiceRegister extends Vue {
    constructor() {
        super(...arguments);
        this.user = this.$store.state.user;
        this.loading = false;
        this.invoice = null;
        this.state = [
            'AGUASCALIENTES',
            'BAJA CALIFORNIA',
            'BAJA CALIFORNIA SUR',
            'CAMPECHE',
            'CHIAPAS',
            'CHIHUAHUA',
            'CIUDAD DE MEXICO',
            'COAHUILA',
            'COLIMA',
            'DURANGO',
            'ESTADO DE MEXICO',
            'GUANAJUATO',
            'GUERRERO',
            'HIDALGO',
            'JALISCO',
            'SAN LUIS POTOSI',
            'MICHOACAN',
            'MORELOS',
            'NAYARIT',
            'NUEVO LEON',
            'OAXACA',
            'PUEBLA',
            'QUERETARO',
            'QUINTANA ROO',
            'SINALOA',
            'SONORA',
            'TABASCO',
            'TAMAULIPAS',
            'TLAXCALA',
            'VERACRUZ',
            'YUCATAN',
            'ZACATECAS'
        ];
        this.formData = {
            name: '',
            email: '',
            phoneNumber: '',
            rfc: '',
            businessName: '',
            address: '',
            extNumber: '',
            intNumber: '',
            postalCode: '',
            state: '',
            locality: '',
            region: ''
        };
        this.formErrors = {
            name: false,
            email: false,
            phoneNumber: false,
            rfc: false,
            businessName: false,
            address: false,
            extNumber: false,
            intNumber: false,
            postalCode: false,
            state: false,
            locality: false,
            region: false
        };
    }
    async created() {
        this.invoice = await UserService.getInvoiceData(this.user.id);
        if (this.invoice) {
            this.formData.name = this.invoice.name;
            this.formData.email = this.invoice.email;
            this.formData.phoneNumber = this.invoice.phoneNumber;
            this.formData.rfc = this.invoice.rfc;
            this.formData.businessName = this.invoice.businessName;
            this.formData.address = this.invoice.address;
            this.formData.extNumber = this.invoice.extNumber;
            this.formData.intNumber = this.invoice.intNumber;
            this.formData.postalCode = this.invoice.postalCode;
            this.formData.state = this.invoice.state;
            this.formData.locality = this.invoice.locality;
            this.formData.region = this.invoice.region;
        }
        else {
            this.formData.name = this.user.name;
            this.formData.email = this.user.email;
            this.formData.phoneNumber = this.user.phone;
        }
    }
    async sendForm() {
        if (this.invoice) {
            if (!this.validForm())
                return;
            await UserService.updateInvoicing(this.invoice, this.user.id);
        }
        else {
            if (!this.validForm())
                return;
            const invoiceOrder = {
                id: '',
                idUser: this.user.id,
                name: this.formData.name,
                email: this.formData.email,
                phoneNumber: this.formData.phoneNumber,
                rfc: this.formData.rfc,
                businessName: this.formData.businessName,
                address: this.formData.address,
                extNumber: this.formData.extNumber,
                intNumber: this.formData.intNumber,
                postalCode: this.formData.postalCode,
                state: this.formData.state,
                locality: this.formData.locality,
                region: this.formData.region
            };
            await UserService.saveInvoincing(invoiceOrder, this.user.id);
        }
        this.$router.push('/profile');
    }
    validForm() {
        this.formErrors = {
            name: false,
            email: false,
            phoneNumber: false,
            rfc: false,
            businessName: false,
            address: false,
            extNumber: false,
            intNumber: false,
            postalCode: false,
            state: false,
            locality: false,
            region: false
        };
        if (!this.formData.name)
            this.formErrors.name = true;
        if (!this.formData.email || !/^\S+@.+\.\S+$/.test(this.formData.email))
            this.formErrors.email = true;
        if (!this.formData.phoneNumber || !/^[0-9]{10}$/.test(this.formData.phoneNumber))
            this.formErrors.phoneNumber = true;
        if (!this.formData.rfc)
            this.formErrors.rfc = true;
        if (!this.formData.businessName)
            this.formErrors.businessName = true;
        if (!this.formData.address)
            this.formErrors.address = true;
        if (!this.formData.extNumber)
            this.formErrors.extNumber = true;
        if (!this.formData.intNumber)
            this.formErrors.intNumber = true;
        if (!this.formData.postalCode)
            this.formErrors.postalCode = true;
        if (!this.formData.state)
            this.formErrors.state = true;
        if (!this.formData.locality)
            this.formErrors.locality = true;
        if (!this.formData.region)
            this.formErrors.region = true;
        for (const error of Object.values(this.formErrors)) {
            if (error == true) {
                return false;
            }
        }
        return true;
    }
};
InvoiceRegister = __decorate([
    Component({
        components: {
            CommonHeader,
            AjaxButton
        }
    })
], InvoiceRegister);
export default InvoiceRegister;
